import { uiFlags } from "appworks/ui/flags/ui-flags";
import { Timer } from "appworks/utils/timer";
import { gameLayers } from "game-layers";
import { GamevyIdle } from "gamevy/states/gamevy-idle";
import { PartnerConnectEvents } from "partner-connect/partner-connect-events";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { SignalBinding } from "signals";
import { UpdateRandomMultipliersOnReelsets } from "tgr-utils";

export class TGRIdle extends GamevyIdle {

    protected balanceChangedBinding: SignalBinding;

    public onEnter(): void {
        super.onEnter();
        UpdateRandomMultipliersOnReelsets();

        if (PartnerConnectManager.isHistoryPending()) {
            this.onSkip();
        }

        gameLayers.BetBar.elements.active.balance_value.style.wordWrap = false;

        if (!this.balanceChangedBinding) {
            this.balanceChangedBinding = PartnerConnectEvents.onBalanceChanged.add(() => {
                Timer.setTimeout(() => uiFlags.onFlagsUpdated.dispatch(), 0);
            });
        }
    }
}
